import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function FeaturedGrid() {
  const featured = comics.filter((c) => c.featured);
  const mainFeature = featured[0] || comics[0];
  const sideA = featured.length > 1 ? featured[1] : comics[1];
  const sideB = featured.length > 2 ? featured[2] : comics[2];

  return (
    <section className="pt-28 pb-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-3xl md:text-5xl font-bold leading-tight" style={{ fontFamily: 'var(--font-heading)' }}>
            <span className="text-foreground-950">发现最优质的</span>
            <br />
            <span className="text-primary-500">免费韩漫大全</span>
            <span className="text-foreground-950"> · </span>
            <span className="text-accent-500">韩漫在线阅读</span>
          </h1>
          <p className="mt-4 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            韩国漫画网 — 您的韩漫资源导航站，通过此漫画网址可便捷访问免费韩漫大全，简化寻找优质内容的过程
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
          <div className="lg:row-span-2">
            <Link
              to={`/article/${mainFeature.slug}`}
              className="block relative w-full h-[420px] lg:h-full min-h-[420px] rounded-lg overflow-hidden group cursor-pointer"
            >
              <img
                src={mainFeature.coverImage}
                alt={mainFeature.title}
                title={`${mainFeature.title} - 免费韩漫大全`}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                loading="eager"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
              <div className="absolute bottom-0 left-0 p-6">
                <span className="inline-block px-3 py-1 rounded-full text-xs bg-accent-500 text-background-50 mb-3">{mainFeature.status}</span>
                <h2 className="text-2xl md:text-3xl font-bold text-white mb-2" style={{ fontFamily: 'var(--font-heading)' }}>{mainFeature.title}</h2>
                <p className="text-sm text-white/80 line-clamp-2 max-w-md">{mainFeature.description}</p>
                <div className="flex items-center gap-4 mt-3">
                  <span className="text-xs text-white/70">{mainFeature.author}</span>
                  <span className="text-xs text-white/70"><i className="ri-eye-line mr-1"></i>{mainFeature.views}</span>
                  <span className="text-xs text-accent-300 font-semibold">★ {mainFeature.rating}</span>
                </div>
              </div>
            </Link>
          </div>

          <Link
            to={`/article/${sideA.slug}`}
            className="block relative w-full h-[200px] lg:h-[200px] rounded-lg overflow-hidden group cursor-pointer"
          >
            <img
              src={sideA.bannerImage}
              alt={sideA.title}
              title={`${sideA.title} - 韩漫在线阅读`}
              className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              loading="eager"
            />
            <div className="absolute inset-0 bg-accent-900/50"></div>
            <div className="absolute inset-0 p-6 flex flex-col justify-end">
              <span className="inline-block px-3 py-1 rounded-full text-xs bg-background-50/20 text-white mb-2 w-fit">{sideA.status}</span>
              <h3 className="text-xl font-bold text-white mb-1" style={{ fontFamily: 'var(--font-heading)' }}>{sideA.title}</h3>
              <p className="text-sm text-white/75 line-clamp-1">{sideA.description}</p>
            </div>
          </Link>

          <Link
            to={`/article/${sideB.slug}`}
            className="block relative w-full h-[200px] lg:h-[200px] rounded-lg overflow-hidden group cursor-pointer"
          >
            <img
              src={sideB.bannerImage}
              alt={sideB.title}
              title={`${sideB.title} - 免费韩漫大全`}
              className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              loading="eager"
            />
            <div className="absolute inset-0 bg-primary-900/50"></div>
            <div className="absolute inset-0 p-6 flex flex-col justify-end">
              <span className="inline-block px-3 py-1 rounded-full text-xs bg-background-50/20 text-white mb-2 w-fit">{sideB.status}</span>
              <h3 className="text-xl font-bold text-white mb-1" style={{ fontFamily: 'var(--font-heading)' }}>{sideB.title}</h3>
              <p className="text-sm text-white/75 line-clamp-1">{sideB.description}</p>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}